var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28 18.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_11-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M26,7.25a3.56,3.56,0,0,0-3.28-3.43H16.88V0H9.1V3.82H0V18.46H4.2a3.18,3.18,0,0,0,3.45-3.17v-.66h5.81a3.32,3.32,0,0,0,3.42-3,1,1,0,0,0,0-.25V4.61h1.45v6.72a3.43,3.43,0,0,0,3.61,3.3h4V7.25ZM7.65,4.61H9.1v9.23H7.65Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDefault);
export default __webpack_public_path__ + "static/media/logoDefault.edd40f0664f39d78ca79257a67fccd64.svg";
export { ForwardRef as ReactComponent };